export default __webpack_public_path__ + "static/media/icon-remarks.05709151.svg";